import { isNil } from 'lodash';
import { ReactNode } from 'react';
import { MBLoadingIndicator } from '@shared/components/loading';
import { useChannel } from '@shared/util/hooks';
import { CardChannelContext } from './context';

interface Props {
  channelSlug: string;
  children: ReactNode;
}

export function MBCardChannelProvider({ channelSlug, children }: Props) {
  const channel = useChannel({ channelSlug });
  if (isNil(channel)) {
    return <MBLoadingIndicator fill />;
  }

  return <CardChannelContext.Provider value={channel}>{children}</CardChannelContext.Provider>;
}
